<template>
  <div>
    <v-dialog
      v-model="dialogConfirm.open"
      @keydown.esc="dialogConfirm.open = false"
      persistent
      content-class="small"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-row v-if="dialogConfirm.option === 'Unlock user'">
              <v-col cols="12" sm="12" md="12" lg="12">
                <p class>
                  <b>{{ dialogConfirm.email }}</b> unlocked
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            id="btn-close"
            class="btn-primary"
            @click="dialogConfirm.open = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogConfirmUserManagement',
  props: {
    dialogConfirm: Object
  }
}
</script>
